<template>
<div class="detailsBox">
  <div class="details">
    <div class="details_part1">
      <div class="details_part1_bottom"></div>
      <div class="details_part1_mess">
        <p v-html="form.content" v-if="form.content!=null&&form.content!=''" class="vHtmlMess"></p>
        <img :src="form.activityUrl" alt="" v-if="form.activityUrl!=null&&form.activityUrl!=''">
        <div class="videoBox" v-if="form.activityVideoUrl!=''&&form.activityVideoUrl!=null">
          <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsline="false" :options="playerOptions"></video-player>
        </div>
      </div>
    </div>
    <div class="details_part2">
      <div class="details_part">
        <p class="part_tit">
          <img src="@/assets/活动模板/title_box.jpg" alt="">
          <span>组织机构</span>
        </p>
        <div class="details_part2_bottom"></div>
      </div>
      <div class="part2_mess">
        <div class="part2_mess_box">
          <!-- <p v-if="form.sponsorName!=null&&form.sponsorName!=''">
            主办方
            <span>{{ form.sponsorName }}</span>
          </p>
          <p v-if="form.undertakerName!=null&&form.undertakerName!=''">
            承办方
            <span>{{ form.undertakerName }}</span>
          </p>
          <p v-if="form.jointlyName!=null&&form.jointlyName!=''">
            承办方
            <span>{{ form.jointlyName }}</span>
          </p> -->
          <p v-if="organizationList.length>0" v-for="(item,index) in organizationList" :key="index">
            {{ item.organizationName }}
            <span>{{ item.organizationContent }}</span>
          </p>
          <div class="con_part2" v-if="logoList.length>0">
            <p>合作方</p>
            <div class="con_part2box">
              <img :src="item.url" alt="" v-for="(item,index) in logoList" :key="index">
            </div>
          </div>          
        </div>
      </div>
    </div>
    <div class="details_part3" v-if="wayList.length>0">
      <div class="details_part">
        <p class="part_tit">
          <img src="@/assets/活动模板/title_box.jpg" alt="">
          <span>奖项设置</span> 
        </p>
        <div class="details_part2_bottom"></div>
      </div>
      <div class="part3_mess_box" v-if="wayList.length>0">
        <div class="part3_mess_box_back">
          <div  v-for="(item,index) in wayList" :key="index">
            <div class="wayBack">
              <!-- <div class="wayBack_box" style="margin-right:20px">
                <i class="wayBack_box_line"></i>
                <i class="wayBack_box_round"></i>
              </div> -->
              <div class="flex wayCss_box">
                <p class="wayCss"> 赛道{{ numberFilter(index+1) }}：</p>
                <p class="wayCss"> {{ item.name }} </p>
              </div>
            </div>
            <carousel-box3 :awardList='item.awardList' :awardIndex="index + 1"></carousel-box3>
          </div>
        </div>
      </div>
    </div>
    <div class="details_part4">
      <div class="details_part">
        <p class="part_tit">
          <img src="@/assets/活动模板/title_box.jpg" alt="">
          <span>活动时间</span>
        </p>
        <div class="details_part2_bottom"></div>
      </div>
      <div class="part4_time_box">
        <div class="part4_time_boxTwo">
          <div class="part4_time">
            <img src="../../../assets/activelistImg/liu2.png" alt="" class="part4_time_img">
            <div :class="'part4_time_date part4_time_date_mess'+(index+1)"
                 v-for="(item,index) in nodeList"
                 :key="index"
                 v-if="nodeList.length>0">
              <p class="part4_time_date1">{{ item.name }}</p>
              <p class="part4_time_date2">{{ getDateYear(item.startDate) }}</p>
              <p class="part4_time_date3" v-if="item.dateType==='DATE'">{{ getDateMonth(item.startDate) }}</p>
              <p class="part4_time_date3" v-if="item.dateType==='RANGE'">
                <span>{{ getDateMonth(item.startDate) }}</span>
                <i class="el-icon-caret-right"></i>
                <span>{{ getDateMonth(item.endDate) }}</span>
              </p>
            </div>
            <!--<div class="part4_time_date">
              <p class="part4_time_date1">活动准备</p>
              <p class="part4_time_date2">{{ getDateYear(form.editDate) }}</p>
              <p class="part4_time_date3">{{ getDateMonth(form.editDate) }}</p>
            </div>
            <div class="part4_time_date part4_time_date_mess2">
              <p class="part4_time_date1">活动征集</p>
              <p class="part4_time_date2">{{ getDateYear(form.activityCollectStartTime) }}</p>
              <p class="part4_time_date3">
                <span>{{ getDateMonth(form.activityCollectStartTime) }}</span>
                <i class="el-icon-caret-right"></i>
                <span>{{ getDateMonth(form.activityCollectEndTime) }}</span>
              </p>
            </div>
            <div class="part4_time_date part4_time_date_mess3">
              <p class="part4_time_date1">活动评选</p>
              <p class="part4_time_date2">{{ getDateYear(form.activityChooseStartTime) }}</p>
              <p class="part4_time_date3">
                <span>{{ getDateMonth(form.activityChooseStartTime) }}</span>
                <i class="el-icon-caret-right"></i>
                <span>{{ getDateMonth(form.activityChooseEndTime) }}</span>
              </p>
            </div>
            <div class="part4_time_date part4_time_date_mess4">
              <p class="part4_time_date1">活动公示</p>
              <p class="part4_time_date2">{{ getDateYear(form.activityShowStartDate) }}</p>
              <p class="part4_time_date3">{{ getDateMonth(form.activityShowStartDate) }}</p>
            </div>-->
          </div>           
        </div>
       
      </div>

    </div>
    <div class="details_part5 clearfix" v-if="form.entryDemand!=null&&form.entryDemand!=''">
      <div class="details_part">
        <p class="part_tit">
          <img src="@/assets/活动模板/title_box.jpg" alt="">
          <span>参赛要求</span>
        </p>
        <div class="details_part2_bottom"></div>
      </div>
      <div class="part5_mess_box clearfix">
        <div class="part5_mess clearfix vHtmlMess" v-html="form.entryDemand">
      </div>
        <!-- <p v-html="form.entryDemand"></p> -->
      </div>
    </div>
    <div class="details_part6" v-if="form.entryRule!=null&&form.entryRule!=''">
      <div class="details_part">
        <p class="part_tit">
          <img src="@/assets/活动模板/title_box.jpg" alt="">
          <span>参赛规则</span>
        </p>
        <div class="details_part2_bottom"></div>
      </div>
      <div class="part6_mess">
        <div class="part6_mess_box">
          <p class="vHtmlMess" v-html="form.entryRule"></p>
        </div>
      </div>
    </div>
    <div class="details_part7" v-show="fileList.length > 0 || form.fileContent">
      <div class="details_part_xiang">
        <p class="part_tit">
          <span>相关资料</span>
        </p>
        <div class="part7_left"></div>
        <div class="part7_right"></div>
      </div>
      <div class="part7_mess">
        <div class="part7_mes_box vHtmlMess" v-html="form.fileContent" v-if="form.fileContent!=null&&form.fileContent!=''"></div>
        <div class="part7_button" v-if="fileList.length>0">
          <p v-for="(item,index) in form.fileList" :key="index" @click="downloadFile(item.url,item.name)">{{ item.name }}</p>
        </div>
      </div>
      <div class="part7_mess_cil">
        <div class="part7_mess_cil_box">
          <img src="@/assets/活动模板/cirle.png" alt="">
          <!-- <div class="part7_mess_cil_p">
            <p>安徽增材云数字科技有限公司</p>
            <p>版权所有 ©️ 2021</p>          
          </div> -->
        </div>
      </div>
    </div>
  </div>  
</div>

</template>
<script>
import { getActivityDetailInfo } from '../../../utils/interface';
import carouselBox3 from './carouselBox3';

export default {
  name:"activeDetailsRefs",
  data(){
    return {
      form:{},
      logoList:[],
      awardList:[],
      fileList:[],
      nodeList:[],
      wayList:[],
      organizationList:[],
      playerOptions : {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器
        sources: [{
          type: "video/mp4",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
          src: "" //url地址
        }],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          fullscreenToggle: false  //全屏按钮
        },
      },
    }
  },
  components:{
    carouselBox3
  },
  mounted(){

  },
  methods: {
    numberFilter (num) {
      const changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'] // changeNum[0] = "零"
      const unit = ['', '十', '百']
      num = parseInt(num)
      const getWan = (temp) => {
        const strArr = temp.toString().split('').reverse()
        let newNum = ''
        for (let i = 0; i < strArr.length; i++) {
          newNum = (i == 0 && strArr[i] == 0 ? '' : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? '' : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum
        }
        return newNum
      }
      const overWan = Math.floor(num / 100)
      let noWan = num % 100
      if (noWan.toString().length < 2) noWan = '0' + noWan;
      let strr = (overWan ? getWan(overWan) + '百' + getWan(noWan) : getWan(num))
      if(strr.split('')[0] == '一'){
        let showNum = "";
        if(strr == '一'){
          showNum = strr.substring(0);
        }else{
          showNum = strr.substring(1);
        }
        return showNum
      }else{
        let showNum = overWan ? getWan(overWan) + '百' + getWan(noWan) : getWan(num);
        return showNum
      }
    },
    init(uuid) {
      console.log('jjj',uuid );
      this.form = {};
      getActivityDetailInfo({uuid:uuid}).then((res)=>{
        this.form = res;
        this.logoList = res.logoList;
        //this.awardList = res.awardList;
        this.fileList = res.fileList;
        this.nodeList = res.nodeList;
        this.wayList = res.wayList;
        this.organizationList = res.organizationList;
        if(this.form.activityVideoUrl!=''){
          this.playerOptions.sources[0].src = this.form.activityVideoUrl;
        }
      });
    },
    getDateYear(value){
      let date = new Date(value);
      let y = date.getFullYear();
      return y;
    },
    getDateMonth(value){
      let date = new Date(value);
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return MM + "." + d;
    },
    downloadFile(fileUrl,name){
      const x = new window.XMLHttpRequest();
      x.open('GET', fileUrl, true);
      x.responseType = 'blob';
      x.onload = () => {
          const url = window.URL.createObjectURL(x.response);
          const a = document.createElement('a');
          a.href = url;
          a.download = name;
          a.click();
      };
      x.send();
    },
    // downloadFile(fileUrl){
    //   let a = document.createElement('a');
    //   a.href = fileUrl;
    //   a.click();
    // },
  },
}
</script>
<style scoped lang="less">
.detailsBox {
  width: 1200px;
  box-sizing: border-box;
  margin: 25px auto 51px;
  padding: 20px 0;
}
.details {
  // background: #f0e6ee;
  margin: 0 auto;
  box-sizing: border-box;
  .details_part {
    font-family: PingFang SC;
    text-align: center;
    position: relative;
    .details_part2_bottom {
      position: absolute;
      width: 100%;
      height: 110px;
      background: #f78b0b;
      border: 10px solid rgb(43, 20, 20);
      border-radius: 35px;
      bottom: -64px;
      box-sizing: border-box;
    }
    .part_tit {
      z-index: 9;
      position: relative;
      font-size: 48px;
      color: #fff;
      img {
        width: 1000px;
      }
      span {
        position: absolute;
        top: 60%;
        left: 50%;
        transform: translate(-36%, -28%);
      }
    }
    .part_line {
      display: inline-block;
      width: 400px;
      height: 2px;
      background: #A70157;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      z-index: -1;

    }
    .part_eng {
      font-size: 12px;
      font-family: PingFang SC;
      color: #A70157;
      opacity: 0.32;
    }
  }
  .details_part1 {
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    padding: 0 70px 50px;
    background: #efba3c;
    border: 10px solid rgb(43, 20, 20);
    border-radius: 48px;
    position: relative;
    z-index: 9;
    margin-top: 46px;
    .details_part1_bottom {
      width: 100%;
      height: 100%;
      background: #efba3c;
      border: 10px solid rgb(43, 20, 20);
      border-radius: 48px;
      position: absolute;
      top: -40px;
      left: -10px;
      z-index: -1;
    }  
    .details_part1_mess {
      font-size: 14px;
      line-height: 28px;
      text-align: center;
      z-index: 6;
      p {
        margin-bottom: 28px;
      }
      /deep/img {
        max-width: 100%;
      }
      .videoBox {
        width: 960px;
        margin: 0 auto;
        /deep/.vjs-custom-skin > .video-js {
          border-radius: 40px;
        }
        /deep/.video-js .vjs-tech {
          border-radius: 34px;
        }
        /deep/.vjs-custom-skin > .video-js .vjs-control-bar {
          border-radius: 0 0 34px 34px;
        }

      }
    }
    .part1_video {
      width: 961px;
      height: 486px;
      background: rgba(243, 243, 243, 0.39);
      border-radius: 10px;;
    }
  }
  .details_part2 {
    margin: 93px 0 83px;
    position: relative;
    .part2_mess {
      box-sizing: border-box;
      font-size: 16px;
      color: #646464;
      width: 100%;
      box-sizing: border-box;
      text-align: center;
      background: #efba3c;
      border: 10px solid rgb(43, 20, 20);
      border-radius: 35px;
      position: relative;
      z-index: 9;
      .part2_mess_box {
        background: #fff;
        margin: 20px;
        border-radius: 10px;
        padding: 40px 20px;
      }
      p {
        display: flex;
        margin-bottom: 19px;
        flex-shrink: 0;
        span {
          margin-left: 8px;
          color: #099;
        }
      }
      .con_part2 {
        margin-top: 27px;
        display: flex;
        // align-items: center;
        color: #646464;
        margin-bottom: 8px;
        flex-shrink: 0;

        .con_part2box {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
        img {
            width: 169px;
            height: 75px;
            margin-right: 24px;
            margin-left: 8px;
            margin-bottom: 15px;
          }
        }
        p {
          align-items: flex-start;
          margin-top: 10px;
        }

      }
    }
  }
  .details_part3 {
    margin-bottom: 50px;
    .part3_mess {
      padding-top: 62px;
      display: flex;
      // justify-content: space-between;
      align-items: center;
      overflow-x: auto;
      /*定义滚动条样式*/
      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background: rgba(240,240,240,1);
      }
　　   /*定义滚动条轨道内阴影+圆角*/
      ::-webkit-scrollbar-track {
        box-shadow: inset000pxrgba(240,240,240,.5);
        border-radius: 10px;
        background: rgba(240,240,240,.5);
      }
  　　/*定义滑块内阴影+圆角*/
      ::-webkit-slider-thumb {
        border-radius: 10px;
        box-shadow: inset000pxrgba(240,240,240,.5);
        background: rgba(240,240,240,.5);
      }
    }
    .part3_mess_pre {
      position: relative;
      font-size: 18px;
      font-weight: bold;
      color: #000000;
      width: 249px;
      height: 307px;
      background: rgba(248, 248, 248);
      border-radius: 10px;
      margin-right: 115px;
      flex-shrink: 0;
      &:nth-last-of-type(1){
        margin-right: 0;
      }
      .pre_part3_tit {
        width: 137px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        background: rgba(21, 126, 251);
        border-radius: 26px;
        color: #fff;
        position: absolute;
        left: 50%;
        top: -6%;
        transform: translate(-50%, 0);
      }
      .pre_part3_me {
        text-align: center;
        padding-top: 24%;
      }
      img {
        width: 120px;
        height: 154px;
        position: absolute;
        bottom: 8px;
        right: -17px;
      }
    }
    .part3_mess_pre:nth-of-type(2)  {
      position: relative;
      font-size: 22px;
      font-weight: bold;
      color: #000000;
      width: 306px;
      height: 378px;
      background: rgba(248, 248, 248);
      border-radius: 10px;
      .pre_part3_tit {
        width: 168px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: rgba(21, 126, 251);
        border-radius: 26px;
        color: #fff;
        position: absolute;
        left: 50%;
        top: -6%;
        transform: translate(-50%, 0);
      }
      .pre_part3_me {
        text-align: center;
        padding-top: 24%;
        font-size: 21px;
      }
      img {
        width: 396px;
        height: 133px;
        position: absolute;
        bottom: 8px;
        right: -78px;
      }
    }
    .part3_mess_box {
      box-sizing: border-box;
      font-size: 16px;
      color: #646464;
      width: 100%;
      box-sizing: border-box;
      text-align: center;
      background: #efba3c;
      border: 10px solid rgb(43, 20, 20);
      border-radius: 35px;
      position: relative;
      z-index: 9;
      padding: 20px 0;
      .part3_mess_box_back {
        background:#fff;
        margin: 0 20px;
        border-radius: 10px;
      }
    }
  }
  .details_part4 {
    margin-bottom: 88px;
    .part4_time_box {
      box-sizing: border-box;
      font-size: 16px;
      color: #646464;
      width: 100%;
      box-sizing: border-box;
      text-align: center;
      background: #efba3c;
      border: 10px solid rgb(43, 20, 20);
      border-radius: 35px;
      position: relative;
      z-index: 9;
      padding: 20px;
    }
    .part4_time_boxTwo {
      background: #fff;
      border-radius: 10px;
    }
    .part4_time {
      position: relative;
      height: 390px;
      // background: #fff;
      .part4_time_img {
        width: 72%;
        position: absolute;
        left: 14%;
        top: 53%;
      }
      .part4_time_date {
        position: absolute;
        top: 70px;
        left: 9%;
        .part4_time_date1 {
          width: 120px;
          height: 40px;
          background: #f2a348;
          border-radius: 20px;
          font-size: 16px;    
          color: #fff;   
          line-height: 40px;
          text-align: center;
        }
        .part4_time_date2 {
          font-size: 16px;
          margin: 3px 0;
        }
        .part4_time_date3 {
          font-size: 24px;
          font-weight: bold;
        }
      }
      .part4_time_date_mess2 {
        top: 244px;
        left: 28%;
        .part4_time_date3 {
          display: flex;
          align-items: center;
          i {
            color: rgba(216, 216, 216);
            font-size: 17px;
            margin: 0 5px;
          }
        }
      }
      .part4_time_date_mess3 {
        left: 49%;
        .part4_time_date3 {
          display: flex;
          align-items: center;
          i {
            color: rgba(216, 216, 216);
            font-size: 17px;
            margin: 0 5px;
          }
        }
      }
      .part4_time_date_mess4 {
        top: 244px;
        left: 71%;
      }

    }
  }
  .details_part5 {
    margin-bottom: 100px;
    .part5_mess_box {
      box-sizing: border-box;
      font-size: 16px;
      color: #646464;
      width: 100%;
      box-sizing: border-box;
      text-align: center;
      background: #efba3c;
      border: 10px solid rgb(43, 20, 20);
      border-radius: 35px;
      position: relative;
      z-index: 9;
      padding: 20px;
    }
    .part5_mess {
      background: #fff;
      padding: 20px;
      border-radius: 20px;
      /deep/img {
        max-width: 100%;
      }
      
      // font-size: 14px;
      // color: #646464;
      // line-height: 28px;
    }
      .clearfix::after{
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  }
  .clearfix::after{
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  .details_part6 {
    margin-bottom: 23px;
    position: relative;
    .part6_mess {
      box-sizing: border-box;
      font-size: 16px;
      color: #646464;
      width: 100%;
      box-sizing: border-box;
      text-align: center;
      background: #efba3c;
      border: 10px solid rgb(43, 20, 20);
      border-radius: 35px;
      position: relative;
      z-index: 9;
      padding: 20px;
      .part6_mess_box {
        padding: 20px;
        border-radius: 20px;
        background: #fff;
        /deep/img {
          max-width: 100%;
        }
        // font-size: 14px;
        // line-height: 28px;
        // color: #646464;
        &:nth-of-type(1){
          margin-bottom: 30px;
        }
      }
    }
  }
  .details_part7 {
    position: relative;
    z-index: 9;
    .part7_mess_cil {
      z-index: -1;
      position: absolute;
      bottom: -238px;
      left: -56px;
      color: #fff;
      text-align: center;
      .part7_mess_cil_box {
        position: relative;
        .part7_mess_cil_p {
          position: absolute;
          bottom: 21%;
          left: 50%;
          transform: translate(-50%,-50%);
          p {
            margin-bottom: 10px;
          }        
        }

        img {
          width: 1317px;
          height: 378px;
        }        
      }
    }
    .details_part_xiang {
      font-family: PingFang SC;
      text-align: center;
      margin-bottom: 40px;
      position: relative;
      .part_tit {
        z-index: 9;
        position: relative;
        font-size: 48px;
        color: #fff;
      }
      .part7_left {
        background: #f78b0b;
        position: absolute;
        width: 30px;
        height: 137px;
        border-left: 10px solid rgb(43, 20, 20);
        border-right: 10px solid rgb(43, 20, 20);
        top: -29px;
        left: 6%;
      }
      .part7_right {
        background: #f78b0b;
        position: absolute;
        width: 30px;
        height: 137px;
        border-left: 10px solid rgb(43, 20, 20);
        border-right: 10px solid rgb(43, 20, 20);
        top: -29px;
        right: 6%;
      }
    }
    .part7_mess {
      width: 100%;
      background: #f78b0b;
      border: 10px solid rgb(43, 20, 20);
      border-radius: 35px;
      padding: 30px;
      box-sizing: border-box;
      margin-bottom: 245px;
      z-index: 7;
      .part7_mes_box {
        margin: 32px 0 20px;
        /deep/img {
          max-width: 100%;
        }
      }
      .part7_button {
        // display: flex;
        // align-items: center;
        cursor: pointer;
        .part7_button_icon {
          width: 40px;
          height: 40px;
          background: rgba(245, 245, 245, 0.39);
          border-radius: 12px;
          color: #04704c;
          text-align: center;
          line-height: 40px;
          i {
            font-size: 30px;
            color: #04704c;
          }
        }
        p {
          font-size: 14px;
          color: #04704c;
          margin-bottom: 9px;
        }
      }
    }
  }
  .wayBack{
    display: flex;
    align-items: center;
    justify-content: center;
    .wayBack_box {
      display: flex;
      align-items: center;
      i {
        display: inline-block;
      }
      .wayBack_box_line {
        width: 74px;
        height: 2px;
        background: #442cf4;
      }
      
      .wayBack_box_round {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #442cf4;
      }
    }
    .wayCss_box{
      background: url("../../../assets/activelistImg/winnerTitle.png") no-repeat;
      background-size: 100% 100%;
      padding: 11px 63px;
      margin-top: 30px;
      .wayCss{
        margin: 4px 0;
        font-size: 18px;
        color: #fff;
      }      
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/design/activeList/activeZhuthreeDetail.vue